import React from "react";
import {useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState} from "recoil";
import BaseModal from "./BaseModal";
import activeModalState from "../../state/ui/activeModalState";
import useOuterClick from "../../hooks/ui/useOuterClick";
import accessTokenState from "../../state/accessTokenState";
import queryClient from "../../services/queryClient";
import {useParams} from "react-router-dom";
import loggedOutState from "../../state/loggedOutState";
import windowDimensionState from "../../state/ui/windowDimensionState";
import { useTranslation } from "react-i18next";

export default function FindCodeModal() {
  const {t} = useTranslation('guest')
  const [activeModal, setShowModal] = useRecoilState(activeModalState);
  const windowDimensions = useRecoilValue(windowDimensionState);

  const innerRef = useOuterClick(ev => {
    setShowModal('');
  });

  return (
    <BaseModal show={activeModal === 'findcode'} center autoHeight large fullHeight>
      <div className="w-full relative p-4" ref={innerRef}>
        <button onClick={()=>setShowModal('')} className="absolute top-0 right-0 m-2">
            <i className="fas fa-times text-lg fa-fw" />
        </button>
        <h4 className="font-bold mb-3 text-lg">{t('find-passcode-title')}</h4>
        <p>
            {t('find-passcode-instruction')}
        </p>
        
      </div>
    </BaseModal>
  )
}
